<div class="flex gap-2xs p-0 text-vermilion-70">
  <div class="shadow-2 flex justify-center items-center h-[14px] mt-[7px] w-[14px] rounded-full {{ iconColor }}">
    <fa-icon size="2xs" [icon]="checkIcon" class="h-fit pb-[1px] text-white"></fa-icon>
  </div>
  <ng-content></ng-content>
</div>
